<div class="profile-details">
  <p class="photo-label">Profile Photo</p>
  <div class="profile-photo-section">
    <div class="photo-container">
      <img *ngIf="profileImageUrl && !isImageUploading" [src]="profileImageUrl" alt="" class="profile-image">
      <span *ngIf="!profileImageUrl && !isImageUploading" class="initials">{{ initials }}</span>
      
      <!-- Spinner loader during image upload -->
      <div *ngIf="isImageUploading" class="upload-spinner">
        <div class="spinner"></div>
        <!-- <p>Uploading...</p> -->
      </div>
    </div>
    <div class="photo-info">
      <p class="photo-guidelines">
        Maximum image size: 20MB<br /> Supported format: JPG or PNG <br/> Best results: 500px
      </p>
      <div class="photo-buttons">
        <button class="upload-button" type="button"   [disabled]=" isImageUploading" (click)="fileInput.click()">
          {{ profileImageUrl ? 'Change photo' : 'Upload photo' }}
        </button>
        <button class="upload-button" *ngIf="profileImageUrl "   type="button"  (click)="removePhoto()">
          Remove photo
        </button>
        <div *ngIf="uploadError" class="error-message upload-error" style="color: red; margin-bottom: 15px;">
          {{ uploadError }}
        </div>
      </div>
      <input hidden #fileInput type="file" (change)="onFileSelected($event)" accept="image/png, image/jpeg, image/jpg">
    </div>
  </div>
 
  <form class="profile-form" [formGroup]="profileForm" (ngSubmit)="onSubmit()" >
    <div class="form-row">
      <div class="form-group" >
        <label for="fullName">Full Name<span class="required">*</span></label>
        <input type="text" class="form-control" id="fullName" formControlName="fullName" maxlength="100" />
        <div *ngIf="fullName?.invalid && (fullName?.dirty || fullName?.touched)" class="error-message">
          <div *ngIf="fullName?.errors?.['required']">
            Full name is required.
          </div>
          <div *ngIf="fullName?.errors?.['standardName']">
            {{ fullName?.errors?.['standardName']?.message }}
          </div>
          <div *ngIf="fullName?.errors?.['maxlength']">
            Full name cannot exceed 100 characters.
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="employeeId">Employee ID<span class="required">*</span></label>
        <input type="text" class="form-control" id="employeeId" formControlName="employeeId" maxlength="50" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <label for="email">Email<span class="required">*</span></label>
        <input type="email" class="form-control" id="email" formControlName="email" maxlength="254" />
        <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="error-message">
          <div *ngIf="email?.errors?.['required']">
            Email is required.
          </div>
          <div *ngIf="email?.errors?.['strictEmail']">
            Invalid email address.
          </div>
          <div *ngIf="email?.errors?.['maxlength']">
            Email cannot exceed 254 characters.
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="phoneNumber">Phone Number<span class="required">*</span></label>
        <input type="tel" class="form-control" id="phoneNumber" formControlName="phoneNumber" (keyup)="onPhoneKeyup()" maxlength="15" />
        <div *ngIf="phoneNumber?.invalid && (phoneNumber?.dirty || phoneNumber?.touched || phoneNumber?.value)" class="error-message">
          <div *ngIf="phoneNumber?.errors?.['required']">
            Phone number is required.
          </div>
          <div *ngIf="phoneNumber?.errors?.['usaPhone']">
            {{ phoneNumber?.errors?.['usaPhone']?.message }}
          </div>
          <div *ngIf="phoneNumber?.errors?.['maxlength']">
            Phone number cannot exceed 15 characters.
          </div>
        </div>
      </div>
    </div>
    <div class="form-actions" >
      <!-- <button type="button" class="btn btn-secondary btn-medium" (click)="onCancel()">Cancel</button> -->
      <button class="btn btn-primary btn-medium" type="submit" [ngClass]="{'disabled': profileForm.invalid || !isFormModified || isSubmitting}" [disabled]="profileForm.invalid || !isFormModified || isSubmitting">
        <span *ngIf="isSubmitting" class="button-spinner"></span>
        <span *ngIf="!isSubmitting">Save</span>
        <span *ngIf="isSubmitting">Saving...</span>
      </button>
    </div>
  </form>
</div>
